import Settings from './Settings.js';

export default Settings;